import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contactadmin',
  templateUrl: './contactadmin.component.html',
  styleUrls: ['./contactadmin.component.scss']
})
export class ContactadminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
